import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Tabs } from 'antd'
import LeaveModal from './LeaveModal'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import LeavesList from './Tabs/LeavesList'
import Entitlements from './Tabs/Entitlements'

const { TabPane } = Tabs

class Leaves extends Component {
  render () {
    const { type, option } = this.props

    return (
      <Fragment>
        <LeaveModal key={type} {...this.props} />
        <Tabs defaultActiveKey="list" tabPosition={'left'}>
          <TabPane tab="Leaves" key="list">
            <LeavesList {...this.props} />
          </TabPane>
          {option === 'hr' && (
            <TabPane tab="Entitlements" key="entitlements">
              <Entitlements {...this.props} />
            </TabPane>
          )}
          {/*<TabPane tab="Calendar" key="calendar">*/}
          {/*<LeavesCalendar {...this.props} />*/}
          {/*</TabPane>*/}
        </Tabs>
      </Fragment>
    )
  }
}

Leaves.propTypes = {
  list: PropTypes.array.isRequired,
  option: PropTypes.string.isRequired,
}
Leaves.defaultProps = { list: [] }

export default Leaves
